import moment from 'moment'
import { i18n } from '@shared/i18n'

const defaultFormat = i18n('common.date.format')

export const parseDateModel = ({ day, month, year }, format = defaultFormat) => {
  return moment(`${day}-${month}-${year}`, 'D-M-YYYY').format(format)
}
